import React from "react";
//#region types
import { AccountingFormTypes } from "models/formTypes";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import {
  DashboardButtonGroup,
  FilterButton,
  StyledButton,
  useFilterContext,
  useFloatingMessages,
} from "components/common";
import useCreateExportDialog from "./export/useCreateExportDialog";
import { useFinancialReportService } from "serviceHooks";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const ReconciliationReportActions: React.FC = () => {
  const financialReportService = useFinancialReportService();
  const { enqueueMessage } = useFloatingMessages();
  const { filter } = useFilterContext<AccountingFormTypes.ReconciliationReportFilter>();
  const { displayCreateExportDialog } = useCreateExportDialog();
  const location = useLocation();
  const navigate = useNavigate();

  const showExportedFiles = async () => {
    navigate(UrlHelper.formatPath("/Reports/ExportedFilesView"), {
      state: { background: location },
    });
  };

  const onQueueExport = () => {
    filter?.reconciliationId !== undefined &&
      financialReportService
        .queueExportReconciliations(filter.reconciliationId)
        .then(() =>
          enqueueMessage(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.CreateExportStartedMessage),
            StyleEnums.DisplayType.Success,
            true
          )
        )
        .catch((errors) => {
          enqueueMessage(`${errors.message}`, StyleEnums.DisplayType.Danger, true);
        });
  };

  const onCreateExportClick = () => {
    displayCreateExportDialog(onQueueExport);
  };

  const actionButtons: (React.ReactElement | typeof ACTION_SEPARATOR)[] =
    filter?.reconciliationId === undefined
      ? []
      : [
          <StyledButton size="sm" onClick={onCreateExportClick}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.CreateExport)}
          </StyledButton>,
          ACTION_SEPARATOR,
          <StyledButton size="sm" onClick={showExportedFiles}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.CompletedExports)}
          </StyledButton>,
        ];

  return <DashboardButtonGroup buttons={actionButtons.concat([<FilterButton />])} />;
};

export default ReconciliationReportActions;
